import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import foodSafetyService from '../../services/foodSafetyService';
import PlanSnapshotView from './FoodSafetySnapshotView';

export default function FoodSafetyPublicPlanPage() {
  const { token } = useParams();
  const [data, setData]     = useState(null);
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    foodSafetyService.getPublicPlan(token)
      .then(setData)
      .catch(err => setError(err?.response?.data?.message || 'This link is unavailable.'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="text-center text-muted">
          <div className="spinner-border mb-3" />
          <div>Loading plan…</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ maxWidth: 600, margin: '80px auto', padding: '0 24px', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔒</div>
        <h4 className="fw-bold mb-2">Link Unavailable</h4>
        <p className="text-muted">{error}</p>
      </div>
    );
  }

  const { snapshot, expiresAt, version } = data;
  const expiresDate = expiresAt ? new Date(expiresAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) : null;

  return (
    <div>
      {/* Expiry banner */}
      {expiresDate && (
        <div className="alert alert-info border-0 rounded-0 mb-0 text-center no-print" style={{ fontSize: 13 }}>
          This shared link expires on <strong>{expiresDate}</strong>. Recipients can view but cannot edit this document.
        </div>
      )}

      <PlanSnapshotView snapshot={snapshot} version={version} showPrint />
    </div>
  );
}
